
import Vue from "vue";

export const FIRST_SHIFT_FAQ_SOURCE_URL =
  "https://support.tempstars.com/hc/en-us/articles/17972199426707-First-Shift-Bookings-commonly-asked-FAQ-S";

export default Vue.extend({
  name: "FirstShiftFaqDialog",
  props: {
    value: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    isMobileDialog(): boolean {
      return Boolean(this.$vuetify && this.$vuetify.breakpoint.xsOnly);
    },
    pdfUrl(): string {
      return `${process.env.BASE_URL ||
        "/"}documents/first-shift-bookings-faq.pdf`;
    },
    sourceUrl(): string {
      return FIRST_SHIFT_FAQ_SOURCE_URL;
    }
  }
});
